export const setAllProducts = (products) => ({
    type: "SET_ALLPRODUCTS",
    products
})
// SET_EDITPRODUCT
export const setEditProduct = (product) => ({
    type: "SET_EDITPRODUCT",
    product
})
export const setCartItems = (items) => ({
    type: "SET_CARTITEMS",
    items
})
export const setNewProduct = (newProduct) => ({
    type: "SET_NEWPRODUCT",
    newProduct
})
